export function appendSearchParams(path: string, search: string): string {
  if (!search || path.includes('?')) return path;
  return `${path}${search.startsWith('?') ? search : `?${search}`}`;
}
